module.exports = __webpack_public_path__ + "img/filter_slider_applied.78a6ffdc.svg";